import React from "react";
import "../styles/WhyChooseUs.css";

const WhyChooseUsSection = () => {
  const message = "Need Cricket ID";
  const encodedMessage = encodeURIComponent(message);
  const ContactLink = `https://wa.me/918000047833?text=${encodedMessage}`;
  const whatsappLink = `https://wa.me/918000047833?text=${encodedMessage}`;
  return (
    <>
    <section className="why-choose-us-section">
      <h2 className="why-choose-us-title">What Makes <span className="highlight">Mahadev Book</span>  the Top Choice for <span className="highlight">Gaming Enthusiasts?</span> </h2>
      <p className="why-choose-us-description">
      Mahadev Book Official sets a new standard in online gaming, offering a dynamic and secure platform built for true gaming enthusiasts. Explore a diverse range of thrilling games powered by cutting-edge technology, all while enjoying a safe and responsible gaming environment. At Mahadev Book, your entertainment and security come first. Join today and discover why we’re the go-to destination for next-level online gaming.
      </p>
      <div className="why-choose-us-cards">
        <div className="why-choose-us-card orange">
          <div className="icon-container "><img src="people.webp" alt="Icon"></img></div>
          <h3>Already Joined 40K+ users and enjoying.</h3>
        </div>
        <div className="why-choose-us-card green">
          <div className="icon-container "><img src="lock.webp" alt="Icon"></img></div>
          <h3>Your Information is 100% Secured with us.</h3>
        </div>
        <div className="why-choose-us-card blue">
          <div className="icon-container "><img src="clock.webp" alt="Icon"></img></div>
          <h3>24-hour withdrawal available (unlimited time).</h3>
        </div>
        <div className="why-choose-us-card orange">
          <div className="icon-container"><img src="protection.webp" alt="Icon"></img></div>
          <h3>100% Genuine and Secured.</h3>
        </div>
        <div className="why-choose-us-card green">
          <div className="icon-container"><img src="customer.webp" alt="Icon"></img></div>
          <h3>24x7 customer service available. No need to Worry!</h3>
        </div>
      </div>
      <a
            href={whatsappLink}
            target="_blank"
            rel="noopener noreferrer"
            className="contactus-button"
          >
            Open Your Demo Account
          </a>
          <a
            href={ContactLink}
            target="_blank"
            rel="noopener noreferrer"
            className="contactus-button"
          >
            Contact Us Now
          </a>
    </section>
    </>
  );
};

export default WhyChooseUsSection;
